import { Button, Pagination } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import ErrorMessage from '../../../components/ErrorMessage/ErrorMessage';
import Icon from '../../../components/Icon/Icon';
import MentorRenewalPopup from '../../../components/MentorRenewalPopup/MentorRenewalPopup';
import Spinner from '../../../components/Spinner/Spinner';
import { Props, TableData, TabStatus } from './RenewalTab.model';
import styles from './RenewalTab.module.scss';
import { pageSize, useRenewalTab } from './useRenewalTab';

const RenewalTab = ({ filters }: Props) => {
	const {
		getMentors,
		onChangePagination,
		setSelectedMentor,
		state: { mentors, pagination, selectedMentor, showPopup, tabStatus },
		togglePopup,
	} = useRenewalTab({ filters });

	const intl = useIntl();

	const history = useHistory();

	const renewColumns: ColumnsType<TableData> = [
		{
			dataIndex: 'name',
			render: (name: string, record: TableData) => {
				return (
					<div className={styles.flexCell}>
						<div className={styles.avatar}>
							{record.imageId && !record.isDeleted ? (
								<img src={record.imageId} alt="" />
							) : (
								<Icon color="light" height="12px" name="user" width="12px" />
							)}
						</div>
						{!record.isDeleted
							? name
							: intl.formatMessage({ id: 'userLabels.deletedUser' })}
					</div>
				);
			},
			title: intl.formatMessage({ id: 'table.column.name' }),
		},
		{
			render: (record: TableData) => (
				<Button
					type="default"
					size="large"
					onClick={(event) => {
						event.stopPropagation();
						setSelectedMentor(record);
						togglePopup();
					}}
				>
					<FormattedMessage id="buttons.renew" />
				</Button>
			),
		},
		{
			className: styles.timeLeft,
			dataIndex: 'timeLeft',
			render: (timeLeft: number) =>
				`${timeLeft} ${intl.formatMessage({ id: 'basics.days' })}`,
			title: intl.formatMessage({ id: 'table.column.timeLeft' }),
		},
	];

	const onClickRow = (rowData: TableData) => {
		return {
			onClick: () => {
				history.push(`/users/${rowData.userId}`);
			},
		};
	};
	return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />
			<ErrorMessage
				error={tabStatus === TabStatus.Error}
				onRefresh={getMentors}
				showReport={false}
			/>
			<Table
				columns={renewColumns}
				dataSource={mentors}
				pagination={false}
				onRow={onClickRow}
				rowKey={(rowData: TableData) => rowData.userId}
			/>

			<div className={styles.paginationWrapper}>
				<Pagination
					current={pagination.page}
					pageSize={pageSize}
					total={pagination.total}
					onChange={onChangePagination}
					showSizeChanger={false}
				/>
			</div>

			{selectedMentor && showPopup && (
				<MentorRenewalPopup onClose={togglePopup} user={selectedMentor} />
			)}
		</div>
	);
};

export default RenewalTab;
